import { z } from 'zod';
import type { ContractIssueDto } from './processes';

/** Conversazione di costruzione di un processo (Fase 3). */

export const StartBuildSchema = z.object({
  message: z.string().trim().min(3).max(6000),
  /** Per rivedere un processo esistente (nuova versione del contratto). */
  process_id: z.string().uuid().optional(),
});
export type StartBuildInput = z.infer<typeof StartBuildSchema>;

export const BuildMessageSchema = z.object({ message: z.string().trim().min(1).max(6000) });

export interface BuildConversationSummary {
  id: string;
  title: string;
  status: 'aperta' | 'adottata' | 'archiviata';
  process_id: string | null;
  adopted_process_id: string | null;
  draft_ready: boolean;
  has_draft: boolean;
  updated_at: string;
}

export interface BuildMessageDto {
  id: number;
  role: 'user' | 'assistant';
  content: string;
  questions: Array<{ question: string; why: string }>;
  draft_changed: boolean;
  draft_issues: ContractIssueDto[];
  /** Programmi citati, con lo stato attuale nella mappa dei software (per proporre il collegamento in chat). */
  software: Array<{ nome: string; uso: string; software_id: string | null; feasibility: string | null; has_template: boolean; connected: boolean; assessing: boolean }>;
  /** Azioni del sistema proposte dal motore per ciò che la persona ha scritto, con il perché. */
  actions: Array<{ action: 'importa_persone' | 'collega_programma' | 'collega_posta' | 'carica_export' | 'crea_controllo' | 'crea_indicatore'; text: string; software: string | null }>;
  created_at: string;
}

export interface BuildConversationDetail extends BuildConversationSummary {
  messages: BuildMessageDto[];
  /** Ultima bozza valida, normalizzata e con la procedura derivata, per l'anteprima leggibile. */
  draft: { source: string; contract: unknown; procedure: unknown } | null;
}
